import { checkSignatureStatus } from '@/lib/check-signature-status';

const validations = {
  type: 'DOCSIGNATURE_REQUEST',
  valueKey: 'docSignatureEmbedValue',
};

function getValue(field) {
  const value = field[validations.valueKey];

  if (Object.keys(value || {}).length === 0) {
    field.value = null;
    field.valueObj = {};
    field[validations.valueKey] = {};

    return field;
  }
  const providerData = field[validations.valueKey]?.providerData || {};
  const isDocSigned = checkSignatureStatus(providerData);

  if (!isDocSigned) {
    field.value = null;
    field.initialValue = value;
    return field;
  } else {
    field.value = field.initialValue ? field.initialValue : value;
  }

  field.valueObj = value;
  field[validations.valueKey] = value;

  return value;
}

// eslint-disable-next-line no-unused-vars
function setValue(field) {
  // TODO: implement
}

validations.getValue = getValue;
validations.setValue = setValue;

export default validations;
